import withStyles from "@material-ui/core/styles/withStyles";
import theme, { rawTheme } from "styles/theme";
import { makeStyles } from "@material-ui/core";
import Button from "@material-ui/core/Button";

export const CreateButton = withStyles({
    root: {
        padding: "0px 15px",
        border: `1px solid ${theme.palette.borderColor}`,
        borderRadius: "5px",
        height: "40px",
        margin: "auto 8px",
        minWidth: "110px",
        textTransform: "none",
        fontSize: "14px",
        background: `${rawTheme.palette.darkMint} !important`,
        color: `${rawTheme.palette.white} !important`,
    },
})(Button);

export const useStyles = makeStyles({
    wrapper: {
        height: "calc(100vh - 65px) !important",
        padding: "20px",
        overflow: "hidden",
        background: `${theme.palette.lightestGrey}`,

        "& .description": {
            fontSize: "14px",
            paddingBottom: "20px",
        },
        "& .button-wrapper": {
            display: "flex",
            justifyContent: "flex-end",
        },
        "& .header": {
            display: "grid",
            padding: "20px 0",
            gridTemplateColumns: "0.4fr 2fr 1fr 2fr 1.5fr 1fr 1fr",
            alignItems: "center",
            borderBottom: `2px solid ${theme.palette.borderColor}`,
        },
        "& .listRowsWrapper": {
            height: "calc(100vh - 250px)",
        },
        "& .listRow": {
            display: "grid",
            padding: "20px 0",
            gridTemplateColumns: "0.4fr 2fr 1fr 2fr 1.5fr 1fr 1fr",
            alignItems: "center",
            borderBottom: `1px solid ${theme.palette.borderColor}`,
        },
        "& .listRowItem": {
            textOverflow: "ellipsis",
            overflow: "hidden",
            whiteSpace: "nowrap",
            padding: "0",
        },
        "& .actionIcon": {
            cursor: "pointer",
            marginLeft: "15px",
        },
    },
    paper: { position: "absolute", right: "0", top: "0", zIndex: 2000, width: "100%" },
    bulkActionsContainer: { display: "flex", justifyContent: "center" as "center", padding: "10px" },
    bulkActionsIcon: { margin: "10px", cursor: "pointer" },
});

export const styles = {
    checkbox: { width: "30px", height: "30px" },
};
